import { Edit, Info, Trash2 } from "react-feather";
import {
  ButtonGroup,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import { admins } from "../../../Constant";
import { FEATURE_FUNCTION_SELECTION } from "../../../Constant/FeatureSelection";
import { getStatusData, STATUS_DATA_TYPE } from "../../../Constant/StatusData";
import {
  formatRP,
  formatTimestamp,
  getUser,
} from "../../../Utils/externalFunctions";
import { getDarkDropdown, getStatusBadge } from "../../../Utils/otherFunctions";
import DataTableTitle from "../../DataTableComponents/DataTableTitle";
import { Link } from "react-router-dom";

const getRealokasiColumns = ({
  themeContext,
  handleLihatRealokasi,
  handleEditStatusRealokasi,
  handleDeleteRealokasi,
}) => {
  const columns = [
    {
      name: <DataTableTitle text={"Kode Realokasi"} />,
      selector: (row) =>
        row.id_realokasi ? row.id_realokasi : row.id_realokasi,
      sortable: true,
    },
    {
      name: <DataTableTitle text={"Tanggal Pengajuan"} />,
      selector: (row) =>
        row.waktu_pengajuan
          ? formatTimestamp(row.waktu_pengajuan)
          : row.waktu_pengajuan,
      sortable: true,
    },
    {
      name: <DataTableTitle text={"Diajukan Oleh"} />,
      selector: (row) => row.diajukan_oleh,
      sortable: true,
    },
    {
      name: <DataTableTitle text={"Keterangan"} />,
      selector: (row) => row.keterangan,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Alasan"} />,
      selector: (row) => row.alasan,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Anggaran (Rp.)"} />,
      selector: (row) => formatRP(row.nilai_anggaran),
      sortable: true,
    },
    {
      name: <DataTableTitle text={"Status"} />,
      selector: (row) => {
        const statusData = getStatusData(
          row.id_status_realokasi,
          STATUS_DATA_TYPE.Realokasi
        );
        return getStatusBadge(statusData);
      },
      sortable: true,
    },
  ];

  FEATURE_FUNCTION_SELECTION.Realokasi.Operasi &&
    columns.push({
      name: <DataTableTitle text={"Operasi"} />,
      cell: (row) => (
        <ButtonGroup>
          <UncontrolledDropdown>
            <DropdownToggle caret></DropdownToggle>
            <DropdownMenu>
              <DropdownItem
                className={`d-flex align-items-center gap-2 ${getDarkDropdown(
                  themeContext
                )}`}
                onClick={() => handleLihatRealokasi(row)}
              >
                <Info size={12} />
                Rincian Realokasi
              </DropdownItem>
              <DropdownItem divider />

              {FEATURE_FUNCTION_SELECTION.Realokasi.Update &&
                admins.includes(getUser()) && (
                  <>
                    <Link
                      to={`${process.env.PUBLIC_URL}/realokasi/edit/${row.id}`}
                    >
                      <DropdownItem
                        className={`d-flex align-items-center gap-2 ${getDarkDropdown(
                          themeContext
                        )}`}
                      >
                        <Edit size={12} />
                        Ubah
                      </DropdownItem>
                    </Link>
                    <DropdownItem divider />
                  </>
                )}

              {FEATURE_FUNCTION_SELECTION.Realokasi.UpdateStatus &&
                admins.includes(getUser()) && (
                  <>
                    <DropdownItem
                      className={`d-flex align-items-center gap-2 ${getDarkDropdown(
                        themeContext
                      )}`}
                      onClick={() => handleEditStatusRealokasi(row)}
                    >
                      <Edit size={12} />
                      Edit Status
                    </DropdownItem>
                    <DropdownItem divider />
                  </>
                )}

              {FEATURE_FUNCTION_SELECTION.Realokasi.Delete && (
                <DropdownItem
                  className={`text-danger d-flex align-items-center gap-2 ${getDarkDropdown(
                    themeContext
                  )}`}
                  onClick={() => handleDeleteRealokasi(row)}
                >
                  <Trash2 size={12} />
                  Hapus
                </DropdownItem>
              )}
            </DropdownMenu>
          </UncontrolledDropdown>
        </ButtonGroup>
      ),
    });

  return columns;
};

export default getRealokasiColumns;
